module.exports = __webpack_public_path__ + "sq17-0e6e9bde.png";